module.exports = "/static/assets/5a0757beea208e8af924d09d51352b92.png";